// extracted by mini-css-extract-plugin
export default {"buttonContainer":"GooglePayButton_buttonContainer__XGE0i","androidNativeButtonContainer":"GooglePayButton_androidNativeButtonContainer__Q1yev"};